import { useCallback } from "react";

interface WindowWithSimpleAnalytics extends Window {
  sa_event(x: string, metadata?: Record<string, string | number>): void;
}

export const useSimpleAnalyticsEvent = () => {
  return useCallback((x: string, metadata?: Record<string, string | number>) => {
    if (
      "sa_event" in window &&
      (window as unknown as WindowWithSimpleAnalytics).sa_event !== null &&
      typeof (window as unknown as WindowWithSimpleAnalytics).sa_event === "function"
    ) {
      return (window as unknown as WindowWithSimpleAnalytics).sa_event(x, metadata);
    }
  }, []);
};
